import cx from 'classnames';

import { useMediaQuery } from 'glossDS/hooks/useMediaQuery';

import InfoIcon from 'components/Icons/Info.svg';

import { useServiceSelection } from 'hooks/page/services/useServiceSelection';

import { BuyNowPayLaterPromo } from 'routes/invoices/components/BuyNowPayLaterPromo/BuyNowPayLaterPromo';

import { TService, TServiceOption } from 'types/service';

import { Item } from '../Item/Item';
import { OrganicButton } from '../OrganicButton/OrganicButton';

import s from './Service.module.css';

export interface ServiceProps {
  className?: string;
  service: TService;
  ellipse?: boolean;
  ctaText?: string;
  ctaSelectedText?: string;
  onClick: (guid: string) => void;
  selected?: boolean;
  selectedOption?: TServiceOption;
  listView?: boolean;
  disabled?: boolean;
  serviceProvider?: string;
}

const Service = ({
  className,
  service,
  ctaText = 'Select',
  ctaSelectedText,
  onClick,
  serviceProvider,
  selected,
  selectedOption,
  disabled = false,
  listView = false,
}: ServiceProps) => {
  const { image, name, description } = service;

  const selectedText = selected ? ctaSelectedText : ctaText;
  const {
    displayedPrice,
    toggleNoMatchingProvidersModal,
    onServiceClick,
    depositText,
    durationText,
    optionText,
    renderNoMatchingProviderModal,
    bnplUnitPrice,
    bnplCapabilities,
  } = useServiceSelection({
    service,
    selectedOption,
    disabled,
    onClick,
  });

  const wideScreen = useMediaQuery('(min-width: 1200px)');
  const alignLeft = wideScreen && listView;
  const promoTextAlign = alignLeft ? 'left' : 'center';

  let popovertarget;
  let popovertargetaction;
  const hasOptions = Boolean(service.options?.length);

  if (hasOptions && !selected) {
    popovertarget = 'service-option-modal';
  }
  if (hasOptions) {
    popovertargetaction = 'show';
  }

  return (
    <>
      {renderNoMatchingProviderModal()}
      <Item
        className={className}
        title={name}
        image={image}
        listView={listView}
        selected={selected}
        disabled={disabled}
        button={
          <OrganicButton
            className={s.button}
            onClick={onServiceClick}
            disabled={disabled}
            selected={selected}
            popovertarget={popovertarget}
            popovertargetaction={popovertargetaction}
          >
            {selectedText}
          </OrganicButton>
        }
      >
        {disabled && (
          <Item.Overlay>
            <button
              className={s.disabledMessage}
              onClick={toggleNoMatchingProvidersModal}
            >
              <span>No matching service providers</span>
              <i className={s.disabledServiceIcon}>
                <InfoIcon />
              </i>
            </button>
          </Item.Overlay>
        )}
        {selected && serviceProvider && (
          <p className={s.provider}>with {serviceProvider}</p>
        )}
        {depositText && <p>{depositText}</p>}
        {description && <p>{description}</p>}
        {optionText ? <p data-testid="option">{optionText}</p> : null}
        <p className={s.details}>
          <span>{displayedPrice}</span>
          {durationText && <span>{durationText}</span>}
        </p>
        {bnplUnitPrice ? (
          <div className={cx(s.bnplEligible, { [s.listView]: listView })}>
            <BuyNowPayLaterPromo
              unitAmount={bnplUnitPrice}
              textAlign={promoTextAlign}
              paymentMethodTypes={bnplCapabilities}
            />
          </div>
        ) : null}
      </Item>
    </>
  );
};

export { Service };
